import { render, staticRenderFns } from "./JCvideo.vue?vue&type=template&id=99309a6a&"
import script from "./JCvideo.vue?vue&type=script&lang=js&"
export * from "./JCvideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports